import React, { useRef, useState } from 'react';
import { formatingPrice } from './app.cart.lib';

import SpinNumber from '../components/mpSpinNumber';

const MAX_COUNT = 1000;

const AppCartItem = (props) => {
    const inputRef = useRef(null);
    const price = formatingPrice(props.data.price);

    function changeCountItem(e) {
        //console.log('change-count-item', e.target, e.target.value, e.target.value.replace(/[^0-9]/g, '*'));
        e.stopPropagation();

        let count = Number(e.target.value.replace(/[^0-9]/g, ''));

        if (count > MAX_COUNT) {
            count = MAX_COUNT;
        }

        if (count < 1) {
            count = 0;
        }

        props.changeItem(count, props.data.id);
    }

    function deleteItem(e) {
        e.stopPropagation();
        e.preventDefault();

        props.deleteItem(props.data.id);
    }

    const getSelected = () => {
        let t = '';

        if (window.getSelection) {
            t = window.getSelection();
        } else if (document.getSelection) {
            t = document.getSelection();
        } else if (document.selection) {
            t = document.selection.createRange().text;
        }

        return t;
    };

    const onClickItem = (e) => {
        // if (e.target.getSelection)
        // console.log(getSelected());
        // console.log(window.getSelection().isCollapsed);
        //console.log(props.data);
        if (!window.getSelection().isCollapsed) {
            return;
        }
        // разрешить клик только на товарах в наличии
        if(props.data?.count > -1){
            props.changeCheck(props.data.id);
        }

    };

    const decreaseCount = (event) => {
        event.stopPropagation();
        let count = inputRef.current.value;
        if(count > -1){
            count--;
            props.decreaseCount(count, props.data.id);
        }
    };

    const increaseCount = (event) => {
        event.stopPropagation();
        let count = inputRef.current.value;
        console.log('increaseCount', count, props.increaseCount);
        if(count > -1){
            count++;
            props.increaseCount(count, props.data.id);
        }
    };

    return (
        <div className="row gx-1 py-4 cart-item" onClick={onClickItem}>
            <div className="col-auto">
                <div className="form-check" style={{minWidth:'40px'}}>
                    { (props.data.count > -1)&&(
                        <>
                            <input className="form-check-input"
                                   type="checkbox"
                                   value=""
                                   id="check_1"
                                   checked={(props.data.count>-1) && props.data.checked}
                                   onChange={() => {
                                   }}/>

                            <label className="visually-hidden" htmlFor="check_1">Выбрать товар</label>
                        </>
                        )}
                </div>
            </div>
            <div className="col">
                <div className="row gx-0">
                    <div className="col-auto">
                        {(props.data.count > -1) ?(
                        <div className="ratio ratio-1x1 bg-light" style={{ width: 80 }}>
                            <img className="object-contain"
                                 src={props.data?.preview}
                                 alt=""
                            />
                        </div>):(
                            <div style={{ width: '80px', height:'80px', opacity: '0.25', paddingLeft:'16px' }}>
                            <svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 512 512">
                                {/*<!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->*/}
                                <path d="M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"/>
                            </svg>
                            </div>
                        )}
                    </div>
                    <div className={(props.data.count>-1)?("col ps-4 pe-lg-4"):("col ps-4 pe-lg-4 text-muted")}>
                        <p className="mb-1">{props.data.title}</p>
                        <p className="mb-1 fs-6 fw-bold">{props.data.additional_info}</p>
                        <a href="" className="fs-6 text-muted" onClick={deleteItem}>Удалить</a>
                    </div>
                    <div className="col-lg-5 col-xl-4 mt-4 mt-lg-0">
                        <div className="row gx-2">
                            <div className="col">
                                {(props.data.count >= 0)&&(
                                <div className="position-relative">
                                    <button type="button"
                                            onClick={decreaseCount}
                                            className={`btn btn-link text-dark px-1 position-absolute top-0 start-0${props.data.count <= 1 ? ' opacity-25' : ''}`}
                                            disabled={(props.data.count <= 1) }
                                    >
                                        <svg className="d-block" width="24" height="24">
                                            <use xlinkHref="#icon-minus"/>
                                        </svg>
                                    </button>
                                    {/* используем type="text", чтобы не выводился дефолтный браузерный контрол управления кол-ом */}
                                    <input ref={inputRef}
                                           type="text"
                                           className="form-control text-center px-8"
                                           value={props.data.count}
                                           onInput={changeCountItem}
                                           onClick={(e) => e.stopPropagation()}
                                           aria-label="Количество"
                                            disabled={props.data.count < 0}
                                    />
                                    <button type="button"
                                            onClick={increaseCount}
                                            className={`btn btn-link text-dark px-1 position-absolute top-0 end-0${((props.data.count === MAX_COUNT)||(props.data.count < 0)  || (props.data.id_presence !== 1)) ? ' opacity-25' : ''}`}
                                            disabled={(props.data.count === MAX_COUNT) || (props.data.count < 0)  || (props.data.id_presence !== 1) }
                                    >
                                        <svg className="d-block" width="24" height="24">
                                            <use xlinkHref="#icon-plus"/>
                                        </svg>
                                    </button>
                                </div>
                                    )}
                            </div>
                            {(props.data.count > -1)?(
                                <div className="col text-end">
                                    {/*<div className="fs-4 fw-bold">{props.data.total} ₽</div>*/}
                                    <div className="fs-4 fw-bold">
                                        {/*{props.data.total} ₽*/}
                                        <SpinNumber
                                            val={props.data.total}
                                            time={50}
                                            isFormating={true}
                                        />
                                    </div>

                                    <div className="fs-6 text-muted">{price} ₽ за шт.</div>
                                </div>
                            ):(
                                <div className="col text-end">
                                    {/*<div className="fs-4 fw-bold">{props.data.total} ₽</div>*/}
                                    <div className="fs-4 fw-bold text-nowrap">нет в продаже</div>
                                    <div className="fs-6 text-muted text-nowrap">этот товар больше не продается<br/>и не будет добавлен в заказ</div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AppCartItem;
